import { ApolloClient, ApolloLink } from "@apollo/client";
import { apiKeyLink } from "@src/utils/apollo/links/apiKeyLink";
import { httpLink } from "@src/utils/apollo/links/httpLink";

import { inMemoryCache } from "./inMemoryCache";

export const apolloClient = new ApolloClient({
    cache: inMemoryCache,
    devtools: {
        enabled: process.env.NODE_ENV === "development",
    },
    link: ApolloLink.concat(apiKeyLink, httpLink),
});
